export default {
    en: {
        CHECKBOX_FILTER_TRUE: 'True'
    }
};
